import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function SettingsPage() {

    return (

        <DashboardLayout>

            <div style={{ padding: "30px" }}>

                <h1>Paramètres</h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}